// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"90c80c2e","77":"00ccc015","115":"ba25f6ef","133":"1ee67bd6","222":"22024047","247":"5ec7e946","280":"17cf03eb","320":"e0992ac7","354":"41b73d43","444":"31bd161e","526":"05bf3205","567":"83225daf","716":"05c9d9f1","779":"852d1eab","836":"545e7754","860":"39f9fc7e"}[chunkId] + ".chunk.js";
};